<form [formGroup]="form" class="row">
  <!-- Caso autorizacionTransaccion  -->
  <div class="col-12">
    <mat-form-field appearance="outline" class="col-6">
      <mat-label>Ente Solicitante</mat-label>
      <input formControlName="ente_solicitante" matInput />
    </mat-form-field>
    <mat-form-field appearance="outline" class="dateInput">
      <mat-label>Fecha de Solicitud</mat-label>
      <input
        matInput
        formControlName="fecha_solicitud"
        [matDatepicker]="picker"
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <!-- <mat-error *ngIf="form.get('fecha').hasError('required')"
              >La fecha es <strong>requerida </strong></mat-error
            > -->
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-6">
      <mat-label>Nombres y Apellidos del Solicitante</mat-label>
      <input formControlName="nombre_apellido" matInput />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-6">
      <mat-label>C.I. del Solicitante</mat-label>
      <input ciRif formControlName="ci_solicitante" matInput />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-6">
      <mat-label>Cargo del Solicitante</mat-label>
      <input formControlName="cargo_solicitante" matInput />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-6">
      <mat-label>Area donde labora el Solicitante</mat-label>
      <input formControlName="area_labor_solicitante" matInput />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-6">
      <mat-label>C.I. de la Persona a Validar</mat-label>
      <input ciRif formControlName="ci_a_validar" matInput />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-6">
      <mat-label>Nombres y Apellidos Persona a Validar</mat-label>
      <input formControlName="nombre_apellido_validar" matInput />
    </mat-form-field>
  </div>
</form>
